import { getComposeStore } from 'owa-calendar-compose-store-manager';
import { orchestrator } from 'satcheljs';
import {
    onIsOnlineMeetingChanged,
    updateIsOnlineMeetingExplicitlySet,
    updateWasOnlineMeetingEverAutoSet,
} from 'owa-calendar-compose-form-actions';

orchestrator(onIsOnlineMeetingChanged, actionMessage => {
    const { event } = getComposeStore();
    if (event && actionMessage.isOnlineMeetingExplicitlySet) {
        updateIsOnlineMeetingExplicitlySet();
    }
    if (actionMessage.wasOnlineMeetingEverAutoSet) {
        updateWasOnlineMeetingEverAutoSet();
    }
});
